(function () {
  function initRails(root) {
    root.querySelectorAll("[data-obj-rail]").forEach(function (rail) {
      if (rail.dataset.objReady === "true") return;
      rail.dataset.objReady = "true";
      var track = rail.querySelector("[data-obj-track]");
      if (!track) return;
      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
        return card.getBoundingClientRect().width + gap;
      }
      var prev = rail.querySelector("[data-obj-prev]");
      var next = rail.querySelector("[data-obj-next]");
      if (prev) {
        prev.addEventListener("click", function () {
          track.scrollBy({ left: -step(), behavior: "smooth" });
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          track.scrollBy({ left: step(), behavior: "smooth" });
        });
      }
    });
  }

  function initSticky(root) {
    var bar = root.querySelector("[data-obj-sticky]") || document.querySelector("[data-obj-sticky]");
    if (!bar || bar.dataset.objReady === "true") return;
    var submit = document.querySelector(".product-form__submit");
    if (!submit) return;
    bar.dataset.objReady = "true";
    var priceEl = document.querySelector(".product__info-container .price");
    var priceOut = bar.querySelector("[data-obj-sticky-price]");
    function sync() {
      if (priceEl && priceOut) priceOut.innerHTML = priceEl.innerHTML;
    }
    sync();
    if (priceEl && window.MutationObserver) {
      new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
    var go = bar.querySelector("[data-obj-sticky-go]");
    if (go) {
      go.addEventListener("click", function () {
        submit.click();
        submit.focus();
      });
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle("is-visible", !entry.isIntersecting);
          });
        },
        { threshold: 0.2 }
      ).observe(submit);
    }
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    initRails(scope);
    initSticky(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
